module.exports = __webpack_public_path__ + "static/suelo-01-f7ba9b5b01d82d3b83c47964b3d05acf.jpg";